module.exports = __webpack_public_path__ + "img/BannerNew.ba94ccd6.png";